module.exports = __webpack_public_path__ + "static/media/profile-amanda.8ab8cc06.png";